export enum BillsImportsStatus {
  DUPLICATE= 'DUPLICATE',
  UNEXPECTED = 'UNEXPECTED',
  NO_PROJECT = 'NO_PROJECT'
}
